import { createInertiaApp } from '@inertiajs/react'
import { AppErrorBoundary } from "@/components/app_error_boundary"
import { t } from "@/lib/i18n"
import { reportAppError, setupPostHog } from "@/lib/posthog"
import "../styles/application.css"

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => navigator.serviceWorker.ready)
      .then((registration) => {
        registration.active?.postMessage({
          type: "CACHE_CURRENT_PAGE",
          url: window.location.href,
        })
      })
      .catch((error: unknown) => {
        console.warn("Service worker registration failed.", error)
      })
  })
}

void createInertiaApp({
  pages: "../pages",

  title: (title) => title ? `${title} | ${t("frontend.meta.app_name")}` : t("frontend.meta.default_title"),

  strictMode: true,

  withApp: (app, { page, ssr }) => {
    if (!ssr) {
      setupPostHog(page)
    }

    return <AppErrorBoundary>{app}</AppErrorBoundary>
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).then(() => {
  document.getElementById("app-boot-loading")?.remove()
  window.metimelyHideCrashScreen?.()
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    reportAppError(error, {
      source: "inertia_boot",
      handled: true,
      fatal: true,
    })
    window.metimelyShowCrashScreen?.(error)
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
